import { jsxs as C, jsx as i, Fragment as ie } from "react/jsx-runtime";
import r from "prop-types";
import { forwardRef as Ie, useRef as U, useState as z, useCallback as He, useEffect as oe, createRef as Ve } from "react";
import f, { createGlobalStyle as We, css as Ue } from "styled-components";
import { parse as qe, format as Ye, isBefore as je, isAfter as Ge } from "date-fns";
import { fromZonedTime as Ke } from "date-fns-tz";
import "camelcase-keys";
import "decamelize-keys";
import { decode as Ze } from "he";
import Xe from "lodash";
import Qe from "pluralize";
import Je from "underscore.string/humanize";
import eo from "voca/title_case";
import se from "color";
import oo from "@iconify-icons/ic/baseline-access-time";
import ro from "@iconify-icons/ic/baseline-account-circle";
import to from "@iconify-icons/ic/baseline-add";
import no from "@iconify-icons/ic/baseline-add-circle";
import io from "@iconify-icons/ic/baseline-add-circle-outline";
import ao from "@iconify-icons/ic/baseline-add-location";
import lo from "@iconify-icons/ic/baseline-admin-panel-settings";
import so from "@iconify-icons/ic/baseline-audiotrack";
import co from "@iconify-icons/ic/baseline-calendar-month";
import po from "@iconify-icons/ic/baseline-check";
import mo from "@iconify-icons/ic/baseline-check-circle";
import uo from "@iconify-icons/ic/baseline-close";
import bo from "@iconify-icons/ic/baseline-cloud-upload";
import go from "@iconify-icons/ic/baseline-control-point-duplicate";
import ho from "@iconify-icons/ic/baseline-data-thresholding";
import fo from "@iconify-icons/ic/baseline-delete";
import yo from "@iconify-icons/ic/baseline-dynamic-feed";
import ko from "@iconify-icons/ic/baseline-edit";
import vo from "@iconify-icons/ic/baseline-error";
import xo from "@iconify-icons/ic/baseline-error-outline";
import Co from "@iconify-icons/ic/baseline-file-upload";
import wo from "@iconify-icons/ic/baseline-flag";
import _o from "@iconify-icons/ic/baseline-format-color-fill";
import So from "@iconify-icons/ic/baseline-format-quote";
import To from "@iconify-icons/ic/baseline-fullscreen";
import Io from "@iconify-icons/ic/baseline-fullscreen-exit";
import Eo from "@iconify-icons/ic/baseline-help";
import Oo from "@iconify-icons/ic/baseline-history-toggle-off";
import Ao from "@iconify-icons/ic/baseline-info";
import Do from "@iconify-icons/ic/baseline-list";
import Ro from "@iconify-icons/ic/baseline-menu";
import Lo from "@iconify-icons/ic/baseline-more-vert";
import No from "@iconify-icons/ic/baseline-move-up";
import Po from "@iconify-icons/ic/baseline-pause";
import $o from "@iconify-icons/ic/baseline-people-alt";
import Fo from "@iconify-icons/ic/baseline-people-outline";
import Mo from "@iconify-icons/ic/baseline-picture-as-pdf";
import Bo from "@iconify-icons/ic/baseline-play-arrow";
import zo from "@iconify-icons/ic/baseline-remove";
import Ho from "@iconify-icons/ic/baseline-rotate-right";
import Vo from "@iconify-icons/ic/baseline-search";
import Wo from "@iconify-icons/ic/baseline-send";
import Uo from "@iconify-icons/ic/baseline-space-dashboard";
import qo from "@iconify-icons/ic/baseline-supervisor-account";
import Yo from "@iconify-icons/ic/baseline-text-snippet";
import jo from "@iconify-icons/ic/baseline-timer";
import Go from "@iconify-icons/ic/baseline-video-library";
import Ko from "@iconify-icons/ic/baseline-videocam";
import Zo from "@iconify-icons/ic/baseline-volume-down";
import Xo from "@iconify-icons/ic/baseline-volume-mute";
import Qo from "@iconify-icons/ic/baseline-volume-off";
import Jo from "@iconify-icons/ic/baseline-volume-up";
import er from "@iconify-icons/ic/baseline-warning";
import or from "@iconify-icons/ic/baseline-warning-amber";
import rr from "@iconify-icons/ic/outline-check";
import tr from "@iconify-icons/ic/outline-chevron-left";
import nr from "@iconify-icons/ic/outline-circle";
import ir from "@iconify-icons/ic/outline-flag";
import ar from "@iconify-icons/ic/outline-inventory";
import lr from "@iconify-icons/ic/outline-keyboard-arrow-down";
import dr from "@iconify-icons/ic/outline-keyboard-arrow-up";
import sr from "@iconify-icons/ic/outline-table-chart";
import cr from "@iconify-icons/ic/round-add-location";
import pr from "@iconify-icons/ic/round-person-add";
import mr from "@iconify-icons/ic/round-person-remove";
import ur from "@iconify-icons/ic/round-remove-done";
import br from "@iconify-icons/ic/round-space-dashboard";
import gr from "@iconify-icons/ic/round-update-disabled";
import hr from "@iconify-icons/ic/round-warning";
import fr from "@iconify-icons/ic/sharp-check-circle";
import yr from "@iconify-icons/ic/sharp-notification-important";
import kr from "@iconify-icons/mdi/check-all";
import vr from "@iconify-icons/mdi/chevron-down";
import xr from "@iconify-icons/mdi/chevron-left";
import Cr from "@iconify-icons/mdi/chevron-right";
import wr from "@iconify-icons/mdi/clipboard-text-search";
import _r from "@iconify-icons/mdi/close-circle";
import Sr from "@iconify-icons/mdi/close-circle-outline";
import Tr from "@iconify-icons/mdi/drag-vertical";
import Ir from "@iconify-icons/mdi/eye-off";
import Er from "@iconify-icons/mdi/file-document";
import Or from "@iconify-icons/mdi/file-image";
import Ar from "@iconify-icons/mdi/filter";
import Dr from "@iconify-icons/mdi/format-list-bulleted-square";
import Rr from "@iconify-icons/mdi/information";
import Lr from "@iconify-icons/mdi/lock";
import Nr from "@iconify-icons/mdi/rename-box";
import Pr from "@iconify-icons/mdi/unlocked-outline";
import { enGB as $r } from "date-fns/locale";
import Fr, { registerLocale as Mr } from "react-datepicker";
import ce from "react-dom";
import "react-datepicker/dist/react-datepicker.css";
import Br from "react-dom/client";
import zr from "slugify";
import { v4 as Hr } from "uuid";
import Vr from "popper-max-size-modifier";
import xe from "map-obj";
import Wr from "quick-lru";
import { Icon as K } from "@iconify/react";
import Ur from "@uiw/react-color-colorful";
import { clsx as $ } from "clsx";
import { createPopper as qr } from "@popperjs/core";
import { CSSTransition as Yr } from "react-transition-group";
import { useFloating as jr, offset as Gr, arrow as Kr, flip as Zr, autoUpdate as Xr, useDismiss as Qr, useHover as Jr, useRole as et, useInteractions as ot, FloatingPortal as rt, FloatingArrow as tt } from "@floating-ui/react";
import { useLongPress as nt } from "react-use";
const q = (o) => zr(o, { remove: /[*+~.()'"!:@]/g }).replace(/,|\/|_/g, "-").toLowerCase(), S = (o) => ({
  "data-test-id": o
}), Ce = () => Hr(), _ = () => {
}, na = (o) => o, ia = (o, t = document.createElement("div")) => {
  const a = Br.createRoot(t);
  return a.render(o), [t, a];
}, aa = (o) => {
  o.unmount();
}, la = ({ selector: o, unit: t = "px", unitless: a = !0, variableName: l }) => {
  let s = getComputedStyle(document.querySelector(o)).getPropertyValue(l);
  return a && (s = parseInt(s.replace(t, ""), 10)), s;
}, it = "Etc/GMT", Q = 3600, pe = 60, re = {
  DATE: "dd LLLL yyyy",
  // 08 September 2023
  DATE_TIME: "dd LLLL yyyy 'at' HH:mm 'UTC'",
  // 08 September 2023 at 14:35 UTC
  ISO_DATE: "yyyy-LL-dd",
  // 2023-09-08
  ISO_DATE_TIME: "yyyy-LL-dd'T'HH:mm:ss'.'SSS'Z'",
  // "2023-09-08T14:35:22.392Z"
  TIME: "HH:mm 'UTC'"
  // 14:35 UTC
}, da = {
  HOURS_MINUTES_SECONDS: "HOURS_MINUTES_SECONDS",
  MINUTES_SECONDS: "MINUTES_SECONDS"
}, we = (o, t = re.ISO_DATE_TIME) => o && qe(o, t, /* @__PURE__ */ new Date()), at = (o, t = re.DATE) => o ? Ye(new Date(o).getTime(), t) : "Not set", sa = (o, t = /* @__PURE__ */ new Date()) => o && je(o, t), ca = (o, t = /* @__PURE__ */ new Date()) => o && Ge(o, t), lt = (o, t = it) => o && Ke(o, t), pa = (o, t) => {
  const a = Math.floor(o / Q), l = Math.floor(o % Q / pe), s = o % pe;
  return [
    ...Q < t ? [String(a).padStart(2, "0")] : [],
    String(l).padStart(2, "0"),
    String(s).padStart(2, "0")
  ].join(":");
}, ma = (o) => {
  const t = o.split(":");
  let [a, l, s] = t;
  return t.length === 2 && ([l, s] = t, a = 0), Number(a) * Q + Number(l) * pe + Number(s);
}, dt = (o, t) => o.some((a) => typeof a == "string" ? a === t : (a.lastIndex = 0, a.test(t))), le = new Wr({ maxSize: 1e5 }), _e = (o) => typeof o == "object" && o !== null && !(o instanceof RegExp) && !(o instanceof Error) && !(o instanceof Date), Se = (o, t, a = {}) => {
  if (!_e(o))
    return o;
  const { deep: l = !1, stopPaths: s } = a, p = (b) => (u, g) => {
    if (l && _e(g) && (g = xe(g, p())), !(s && dt(s, u))) {
      const d = `_${u}`;
      if (le.has(d))
        u = le.get(d);
      else {
        const h = t(u);
        u.length < 100 && le.set(d, h), u = h;
      }
    }
    return [u, g];
  };
  return xe(o, p());
};
function ua(o, t, a) {
  return Array.isArray(o) ? Object.keys(o).map((l) => Se(o[l], t, a)) : Se(o, t, a);
}
const ba = (o) => Je(o), Ee = (o, t = {}) => eo(o, t.noSplit), ga = (o, t) => Qe(o, t), ha = (o) => Ze(o.toString()), { camelCase: fa } = Xe, D = {
  small: "1px",
  medium: "2px",
  large: "4px"
}, st = {
  mobile: "430px",
  tablet: "768px"
}, ya = {
  mobile: 430,
  tablet: 768
}, w = (o, t, a) => se(o).mix(se(t), a), P = (o) => Math.round(o / 100 * 255).toString(16).toUpperCase(), e = {
  black: {
    base: "#000000",
    light: "#E7E9EC",
    medium: "#29354B",
    mediumAlpha: (o) => `#29354B${P(o)}`,
    primary: "#000F23",
    primaryAlpha: (o) => `#000F23${P(o)}`,
    secondary: "#263238"
  },
  blue: {
    dark: "#004096",
    darkAlpha: (o) => `#004096${P(o)}`,
    light: "#F4F7FB",
    medium: "#E6ECF9",
    mediumAlpha: "#F3F6FC",
    primary: "#4D84AB",
    primaryAlpha: (o) => `#4D84AB${P(o)}`,
    primaryAlpha10: "#EDF3F7",
    primaryAlpha11: "#EBF1F6",
    secondary: "#CFDBEF",
    tertiary: "#5E6F8E",
    tertiaryAlpha: (o) => `#5E6F8E${P(o)}`
  },
  green: {
    primary: "#5CB85C",
    primaryAlpha: (o) => `#5CB85C${P(o)}`
  },
  grey: {
    admin: "#E0E0E0",
    medium: "#63666A",
    mediumAlpha: (o) => `#63666A${P(o)}`,
    primary: "#3C3C3C",
    primaryAlpha: (o) => `#3C3C3C${P(o)}`,
    quartenary: "#CCCCCC",
    quinery: "#E2E2E2",
    secondary: "#EEEEEE",
    secondaryAlpha: (o) => `#EEEEEE${P(o)}`,
    strong: "#474747",
    tertiary: "#D3D3D3"
  },
  purple: {
    primary: "#6A28D3"
  },
  red: {
    light: "#FFEFF3",
    medium: "#FECBD4",
    primary: "#C8102E",
    primaryAlpha: (o) => `#C8102E${P(o)}`,
    primaryAlpha10: "#FAE7EA",
    primaryAlpha11: "#F9E5E8"
  },
  transparent: "transparent",
  white: {
    primary: "#FFFFFF"
  },
  yellow: {
    light: "#FFF4E4",
    medium: "#FFD79C",
    primary: "#F0AD4E",
    primaryAlpha10: "#FEF7ED",
    primaryAlpha11: "#FDF6EC",
    quartenary: "#FFD486",
    quinery: "#FFF1D9",
    secondary: "#FFA500",
    tertiary: "#8a6d3b"
  }
}, A = {
  xsmall: "8px",
  small: "10px",
  msmall: "11px",
  smedium: "12px",
  medium: "13px",
  slarge: "14px",
  large: "16px",
  mlarge: "20px",
  xlarge: "24px",
  xxlarge: "32px",
  xxxlarge: "48px"
}, me = {
  thin: "100",
  light: "200",
  normal: "400",
  medium: "500",
  bold: "700",
  black: "900"
}, H = {
  hidden: -1,
  elevate: 1,
  elevatePlus: 5,
  header: 10,
  overlay: 100,
  sidebar: 1e3,
  modal: 1e4,
  dropdown: 1e5,
  tooltip: 1e6
}, be = {
  disabled: 0.38
}, n = {
  tiny: "0.125rem",
  // 2px
  xsmall: "0.25rem",
  // 4px
  msmall: "0.375rem",
  // 6px
  small: "0.5rem",
  // 8px
  lsmall: "0.625rem",
  // 10px
  smedium: "0.75rem",
  // 12px
  mmedium: "0.875rem",
  // 14px
  medium: "1rem",
  // 16px
  lmedium: "1.125rem",
  // 18px
  slarge: "1.25rem",
  // 20px
  large: "1.5rem",
  // 24px
  xlarge: "2rem",
  // 32px
  xxlarge: "2.5rem",
  // 40px
  xllarge: "3rem"
  // 48px
}, ct = 100, pt = () => "transition: all 0.1s ease", Y = () => "transition: background-color 0.1s ease;", ka = () => "transition: border-color 0.1s ease;", mt = () => "transition: color 0.1s ease;", G = () => "transition: opacity 0.1s ease;", ge = () => `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`, ut = {
  baselineAccessTime: oo,
  baselineAccountCircle: ro,
  baselineAdd: to,
  baselineAddCircle: no,
  baselineAddCircleOutline: io,
  baselineAddLocation: ao,
  baselineAdminPanelSettings: lo,
  baselineAudiotrack: so,
  baselineCalendarMonth: co,
  baselineCheck: po,
  baselineCheckCircle: mo,
  baselineClose: uo,
  baselineCloudUpload: bo,
  baselineDataThreshold: ho,
  baselineDelete: fo,
  baselineDuplicate: go,
  baselineDynamicFeed: yo,
  baselineEdit: ko,
  baselineError: vo,
  baselineErrorOutline: xo,
  baselineFileUpload: Co,
  baselineFlag: wo,
  baselineFormatColorFill: _o,
  baselineFullscreen: To,
  baselineFullscreenExit: Io,
  baselineHelp: Eo,
  baselineHistoryToggleOff: Oo,
  baselineInfo: Ao,
  baselineList: Do,
  baselineMenu: Ro,
  baselineMoreVert: Lo,
  baselinePause: Po,
  baselinePeopleAlt: $o,
  baselinePeopleOutline: Fo,
  baselinePictureAsPdf: Mo,
  baselinePlayArrow: Bo,
  baselineRemove: zo,
  baselineRotateRight: Ho,
  baselineSearch: Vo,
  baselineSend: Wo,
  baselineSpaceDashboard: Uo,
  baselineSupervisorAccount: qo,
  baselineTextSnippet: Yo,
  baselineTimer: jo,
  baselineUncheckAll: ur,
  baselineVideoLibrary: Go,
  baselineVideocam: Ko,
  baselineVolumeDown: Zo,
  baselineVolumeMute: Xo,
  baselineVolumeOff: Qo,
  baselineVolumeUp: Jo,
  baselineWarning: er,
  baselineWarningAmber: or,
  outlineCheck: rr,
  outlineChevronLeft: tr,
  outlineFlag: ir,
  outlineInventory: ar,
  outlineKeyboardArrowDown: lr,
  outlineKeyboardArrowUp: dr,
  outlineTableChart: sr,
  roundAddLocation: cr,
  roundSpaceDashboard: br,
  roundUpdateDisabled: gr,
  roundWarning: hr,
  sharpCheckCircle: fr,
  sharpNotificationImportant: yr
}, bt = {
  baselineCheckAll: kr,
  baselineChevronDown: vr,
  baselineChevronLeft: xr,
  baselineChevronRight: Cr,
  baselineFileDocument: Er,
  baselineFileImage: Or,
  baselineFilter: Ar,
  baselineFormatBulletList: Dr,
  baselineFormatQuote: So,
  baselineInformation: Rr,
  baselineLock: Lr,
  baselineMoveUp: No,
  baselineUnlock: Pr,
  clipboardTextSearch: wr,
  closeCircle: _r,
  closeCircleOutline: Sr,
  dragVertical: Tr,
  eyeOff: Ir,
  outlineCircle: nr,
  renameBox: Nr,
  roundPersonAdd: pr,
  roundPersonRemove: mr
}, gt = {
  circleClose: (o = 24, t = 24, a = e.black.medium) => /* @__PURE__ */ C("svg", {
    fill: "none",
    height: t,
    viewBox: "0 0 16 17",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ i("g", {
        clipPath: "url(#clip0_6361_277)",
        children: /* @__PURE__ */ i("path", {
          d: "M11.5 5.705L10.795 5L8 7.795L5.205 5L4.5 5.705L7.295 8.5L4.5 11.295L5.205 12L8 9.205L10.795 12L11.5 11.295L8.705 8.5L11.5 5.705Z",
          fill: "#29354B"
        })
      }),
      /* @__PURE__ */ i("rect", {
        height: "15",
        rx: "7.5",
        stroke: "#29354B",
        width: "15",
        x: "0.5",
        y: "1"
      }),
      /* @__PURE__ */ i("defs", {
        children: /* @__PURE__ */ i("clipPath", {
          id: "clip0_6361_277",
          children: /* @__PURE__ */ i("rect", {
            fill: a,
            height: "16",
            rx: "8",
            width: "16",
            y: "0.5"
          })
        })
      })
    ]
  }),
  playlistAddCheck: (o = 24, t = 24, a = e.black.medium) => /* @__PURE__ */ C("svg", {
    fill: "none",
    height: t,
    viewBox: `0 0 ${o} ${t}`,
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ i("g", {
        clipPath: "url(#clip0_5881_4150)",
        children: /* @__PURE__ */ i("g", {
          clipPath: "url(#clip1_5881_4150)",
          children: /* @__PURE__ */ i("path", {
            clipRule: "evenodd",
            d: "M21 3H3V21H21V3ZM13.3333 10.6667H6V12H13.3333V10.6667ZM13.3333 8H6V9.33333H13.3333V8ZM10.6667 13.3333H6V14.6667H10.6667V13.3333ZM14.8933 14.78L17.7267 11.9533L18.6667 12.8933L14.8933 16.6667L12.54 14.3067L13.48 13.3667L14.8933 14.78Z",
            fill: a,
            fillRule: "evenodd"
          })
        })
      }),
      /* @__PURE__ */ C("defs", {
        children: [
          /* @__PURE__ */ i("clipPath", {
            id: "clip0_5881_4150",
            children: /* @__PURE__ */ i("rect", {
              fill: "white",
              height: "24",
              width: "24"
            })
          }),
          /* @__PURE__ */ i("clipPath", {
            id: "clip1_5881_4150",
            children: /* @__PURE__ */ i("rect", {
              fill: "white",
              height: "18",
              rx: "2",
              width: "18",
              x: "3",
              y: "3"
            })
          })
        ]
      })
    ]
  }),
  spinner: {
    body: '<path d="M14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>',
    height: 16,
    width: 16
  }
}, j = {
  ...ut,
  ...bt,
  ...gt
}, R = {
  NORMAL: "normal",
  SLIM: "slim",
  TINY: "tiny"
}, m = {
  LABEL: "label",
  PLAIN: "plain",
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SPECIAL: "special",
  TERTIARY: "tertiary"
}, E = {
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning"
}, J = {
  DARK: "dark",
  LIGHT: "light"
};
function he(o) {
  const { tint: t = J.DARK } = o, a = {
    [J.DARK]: e.black.primary,
    [J.LIGHT]: e.white.primary
  };
  return /* @__PURE__ */ i(ht, {
    className: t,
    children: /* @__PURE__ */ i(K, {
      color: a[t],
      height: 16,
      icon: j.spinner,
      width: 16
    })
  });
}
const ht = f.div.withConfig({
  displayName: "Spinner__Spin",
  componentId: "sc-c2c8d9eb-0"
})([
  "height:16px;width:16px;display:flex;animation:spin 2s infinite linear;@keyframes spin{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}"
]);
he.propTypes = {
  tint: r.oneOf(Object.values(J))
};
const F = /* @__PURE__ */ Ie((o, t) => {
  const { actionType: a = "button", disabled: l = !1, fullWidth: s = !1, icon: p = null, loading: b = !1, noHover: u = !1, noWrap: g = !1, onClick: d = _, size: h = R.NORMAL, text: y = void 0, type: k = m.PRIMARY, variant: v = void 0 } = o, T = "button", I = () => ({
    height: y ? 16 : 32,
    width: y ? 16 : 32
  }), L = () => [
    E.ERROR
  ].includes(v) ? e.red.primary : [
    E.SUCCESS,
    E.WARNING
  ].includes(v) ? e.white.primary : [
    m.LABEL
  ].includes(k) ? e.black.primary : [
    m.SPECIAL
  ].includes(k) ? e.blue.dark : e.white.primary, N = () => [
    E.SUCCESS,
    E.WARNING
  ].includes(v) || [
    m.PRIMARY
  ].includes(k) ? "light" : ([
    m.SECONDARY,
    m.TERTIARY,
    m.LABEL,
    m.SPECIAL
  ].includes(k), "dark"), c = (O) => {
    l || d(O);
  };
  return /* @__PURE__ */ C(kt, {
    ref: t,
    className: $({
      disabled: l,
      "full-width": s,
      loading: b,
      "no-hover": u,
      [h]: !0,
      [k]: !0,
      [v]: v
    }),
    onClick: c,
    type: a,
    ...S(q(`${(y || T).toLowerCase()}-button`)),
    children: [
      b && /* @__PURE__ */ i(ft, {
        ...S(q(`${(y || T).toLowerCase()}-button-loading`)),
        children: /* @__PURE__ */ i(yt, {
          children: /* @__PURE__ */ i(he, {
            tint: N()
          })
        })
      }),
      p && /* @__PURE__ */ i(K, {
        color: L(),
        height: I().height,
        icon: p,
        opacity: b ? 0 : 1,
        style: {
          flexShrink: 0
        },
        width: I().width
      }),
      y && /* @__PURE__ */ i(ue, {
        className: $({
          "hidden-text": b,
          "no-wrap": g
        }),
        children: Ee(y)
      })
    ]
  });
}), ft = f.div.withConfig({
  displayName: "Button__SpinnerWrapper",
  componentId: "sc-b7c7de0-0"
})([
  "position:absolute;width:100%;height:100%;display:grid;place-items:center;z-index:",
  ";"
], H.elevate), yt = f.div.withConfig({
  displayName: "Button__LoadingContainer",
  componentId: "sc-b7c7de0-1"
})([
  "display:flex;align-items:center;justify-content:center;"
]), ue = f.div.withConfig({
  displayName: "Button__ButtonText",
  componentId: "sc-b7c7de0-2"
})([
  "font-size:",
  ";letter-spacing:0.05em;line-height:",
  ";&.hidden-text{opacity:0;}&.no-wrap{",
  "}"
], A.slarge, n.slarge, ge), kt = f.button.withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-b7c7de0-3"
})([
  "position:relative;display:flex;align-items:center;justify-content:center;gap:",
  ";padding:0 ",
  ";border:0;border-radius:",
  ";user-select:none;opacity:1;",
  " cursor:pointer;",
  " &.no-hover:hover{cursor:auto;}&.",
  "{background-color:",
  ";color:",
  ";&:focus:not(.disabled):not(.loading):not(:active):not(.no-hover),&:hover:not(.disabled):not(.loading):not(:active):not(.no-hover){background-color:",
  ";}&:active:not(.disabled):not(.loading):not(.no-hover){background-color:",
  ";}&.",
  "{background-color:",
  ";color:",
  ";&:focus:not(.disabled):not(.loading):not(:active):not(.no-hover),&:hover:not(.disabled):not(.loading):not(:active):not(.no-hover){background-color:",
  ";}&:active:not(.disabled):not(.loading):not(.no-hover){background-color:",
  ";}}&.",
  "{background-color:",
  ";color:",
  ";&:focus:not(.disabled):not(.loading):not(:active):not(.no-hover),&:hover:not(.disabled):not(.loading):not(:active):not(.no-hover){background-color:",
  ";}&:active:not(.disabled):not(.loading):not(.no-hover){background-color:",
  ";}}}&.",
  "{background-color:",
  ";color:",
  ";outline:",
  " solid ",
  ";&:focus:not(.disabled):not(.loading):not(:active):not(.no-hover),&:hover:not(.disabled):not(.loading):not(:active):not(.no-hover){background-color:",
  ";}&:active:not(.disabled):not(.loading):not(.no-hover){background-color:",
  ";}&.",
  "{outline-color:",
  ";color:",
  ";}&.",
  "{outline-color:",
  ";color:",
  ";}}&.",
  "{background-color:",
  ";color:",
  ";&:focus:not(.disabled):not(.loading):not(:active):not(.no-hover),&:hover:not(.disabled):not(.loading):not(:active):not(.no-hover){background-color:",
  ";}&:active:not(.disabled):not(.loading):not(.no-hover){background-color:",
  ";}}&.",
  "{flex-flow:row-reverse;background-color:",
  ";color:",
  ";&:focus:not(.disabled):not(.loading):not(:active):not(.no-hover),&:hover:not(.disabled):not(.loading):not(:active):not(.no-hover){background-color:",
  ";}&:active:not(.disabled):not(.loading):not(.no-hover){background-color:",
  ";}",
  "{letter-spacing:normal;}&.",
  "{background-color:",
  ";color:",
  ";&:focus:not(.disabled):not(.loading):not(:active):not(.no-hover),&:hover:not(.disabled):not(.loading):not(:active):not(.no-hover){background-color:",
  ";}&:active:not(.disabled):not(.loading):not(.no-hover){background-color:",
  ";}}&.",
  "{background-color:",
  ";color:",
  ";&:focus:not(.disabled):not(.loading):not(:active):not(.no-hover),&:hover:not(.disabled):not(.loading):not(:active):not(.no-hover){background-color:",
  ";}&:active:not(.disabled):not(.loading):not(.no-hover){background-color:",
  ";}}}&.",
  "{background-color:",
  ";color:",
  ";outline:",
  " solid ",
  ";&:focus:not(.disabled):not(.loading):not(:active):not(.no-hover),&:hover:not(.disabled):not(.loading):not(:active):not(.no-hover){background-color:",
  ";}&:active:not(.disabled):not(.loading):not(.no-hover){background-color:",
  ";}",
  "{letter-spacing:normal;}&.",
  "{background-color:",
  ";outline-color:",
  ";&:focus:not(.disabled):not(.loading):not(:active):not(.no-hover),&:hover:not(.disabled):not(.loading):not(:active):not(.no-hover){background-color:",
  ";outline:0;}&:active:not(.disabled):not(.loading):not(.no-hover){background-color:",
  ";outline:0;}}}&.",
  "{padding-top:",
  ";padding-bottom:",
  ";}&.",
  "{padding-top:",
  ";padding-bottom:",
  ";}&.disabled{opacity:",
  ";cursor:not-allowed;}&.loading{pointer-events:none;}&.full-width{width:100%;}.icon-padding{padding-right:",
  ";}"
], n.small, n.medium, n.xsmall, G, Y, m.PRIMARY, e.black.medium, e.white.primary, e.blue.dark, w(e.blue.dark, e.black.base, 0.2).hex(), E.SUCCESS, e.green.primary, e.white.primary, w(e.green.primary, e.blue.dark, 0.15).hex(), w(e.green.primary, e.blue.dark, 0.25).hex(), E.WARNING, e.red.primary, e.white.primary, w(e.red.primary, e.blue.dark, 0.15).hex(), w(e.red.primary, e.blue.dark, 0.25).hex(), m.SECONDARY, e.transparent, e.black.medium, D.small, e.black.medium, e.blue.medium, e.blue.light, E.SUCCESS, e.green.primary, e.green.primary, E.WARNING, e.red.primary, e.red.primary, m.TERTIARY, e.transparent, e.black.medium, e.blue.medium, e.blue.light, m.LABEL, e.blue.medium, e.black.medium, w(e.blue.medium, e.blue.dark, 0.15).hex(), w(e.blue.medium, e.blue.dark, 0.25).hex(), ue, E.SUCCESS, e.green.primary, e.white.primary, w(e.green.primary, e.blue.dark, 0.15).hex(), w(e.green.primary, e.blue.dark, 0.25).hex(), E.WARNING, e.red.primary, e.white.primary, w(e.red.primary, e.blue.dark, 0.15).hex(), w(e.red.primary, e.blue.dark, 0.25).hex(), m.SPECIAL, e.blue.light, e.black.medium, D.small, e.blue.dark, e.blue.medium, w(e.blue.medium, e.blue.dark, 0.15).hex(), ue, E.ERROR, e.red.light, e.red.medium, w(e.red.light, e.blue.dark, 0.15).hex(), w(e.red.light, e.blue.dark, 0.25).hex(), R.SLIM, n.msmall, n.msmall, R.NORMAL, n.lsmall, n.lsmall, be.disabled, n.small);
F.propTypes = {
  actionType: r.string,
  disabled: r.bool,
  fullWidth: r.bool,
  icon: r.shape({
    body: r.string.isRequired
  }),
  loading: r.bool,
  noHover: r.bool,
  noWrap: r.bool,
  onClick: r.func,
  size: r.oneOf(Object.values(R)),
  text: r.string,
  type: r.oneOf(Object.values(m)),
  variant: r.oneOf(Object.values(E))
};
const fe = {
  BOTTOM: "bottom",
  BOTTOM_END: "bottom-end",
  BOTTOM_START: "bottom-start",
  LEFT: "left",
  LEFT_END: "left-end",
  LEFT_START: "left-start",
  RIGHT: "right",
  RIGHT_END: "right-end",
  RIGHT_START: "right-start",
  TOP: "top",
  TOP_END: "top-end",
  TOP_START: "top-start"
}, vt = 2e3;
function te(o) {
  const { backgroundColor: t = e.black.medium, children: a, content: l, hasArrow: s = !0, id: p, place: b = fe.TOP, textColor: u = e.white.primary } = o, g = U(null), d = U(null), [h, y] = z(null), k = He(() => {
    d.current && clearTimeout(d.current), y(!0), d.current = setTimeout(() => {
      y(!1);
    }, vt);
  }, []), { context: v, floatingStyles: T, refs: I } = jr({
    middleware: [
      Gr(12),
      Kr({
        element: g
      }),
      Zr({
        fallbackAxisSideDirection: "start"
      })
    ],
    onOpenChange: y,
    open: h,
    placement: b,
    whileElementsMounted: Xr
  }), L = Qr(v), N = Jr(v, {
    mouseOnly: !0,
    move: !1
  }), c = et(v, {
    role: "tooltip"
  }), { getFloatingProps: O, getReferenceProps: M } = ot([
    N,
    L,
    c
  ]), V = nt(k, {
    isPreventDefault: !1
  });
  return oe(() => () => {
    d.current && clearTimeout(d.current);
  }, []), /* @__PURE__ */ C(ie, {
    children: [
      /* @__PURE__ */ i("div", {
        ref: I.setReference,
        ...M(),
        ...V,
        ...S(`tooltip-trigger-${p}`),
        children: a
      }),
      h && l ? /* @__PURE__ */ i(rt, {
        children: /* @__PURE__ */ C(xt, {
          ref: I.setFloating,
          $backgroundColor: t,
          $textColor: u,
          style: T,
          ...O(),
          ...S("tooltip"),
          children: [
            /* @__PURE__ */ i("div", {
              children: l
            }),
            s && /* @__PURE__ */ i(tt, {
              ref: g,
              context: v,
              fill: t,
              ...S("tooltip-arrow")
            })
          ]
        })
      }) : null
    ]
  });
}
const xt = f.div.withConfig({
  displayName: "Tooltip__StyleTooltipContent",
  componentId: "sc-ee8053fc-0"
})([
  "max-width:320px;width:max-content;padding:",
  " ",
  ";border-radius:",
  ";background-color:",
  ";color:",
  ";font-size:",
  ";z-index:",
  ";@media (width <= ",
  "){max-width:300px;}"
], n.small, n.slarge, n.xsmall, (o) => o.$backgroundColor, (o) => o.$textColor, A.smedium, H.tooltip, st.mobile);
te.propTypes = {
  backgroundColor: r.string,
  children: r.node.isRequired,
  content: r.node,
  hasArrow: r.bool,
  id: r.string.isRequired,
  place: r.oneOf(Object.values(fe)),
  textColor: r.string
};
const Te = {
  [R.TINY]: 16,
  [R.SLIM]: 24,
  [R.NORMAL]: 32
}, Ct = {
  [m.PRIMARY]: e.white.primary,
  [m.SECONDARY]: e.black.medium,
  [m.TERTIARY]: e.black.medium,
  [m.PLAIN]: e.black.medium
};
function ne(o) {
  const { color: t = void 0, disabled: a = !1, icon: l, iconProps: s = {}, loading: p = !1, noActive: b = !1, noFocus: u = !1, noHover: g = !1, onClick: d = _, size: h = R.NORMAL, type: y = m.PRIMARY, ...k } = o, v = (I) => {
    a || d(I);
  }, T = () => [
    m.PRIMARY
  ].includes(y) ? "light" : ([
    m.SECONDARY,
    m.TERTIARY,
    m.LABEL,
    m.SPECIAL
  ].includes(y), "dark");
  return /* @__PURE__ */ C(St, {
    className: $({
      disabled: a,
      loading: p,
      "no-active": b,
      "no-focus": u,
      "no-hover": g,
      [h]: !0,
      [y]: !0
    }),
    onClick: v,
    ...k,
    children: [
      p && /* @__PURE__ */ i(wt, {
        ...S(q("icon-button-loading")),
        children: /* @__PURE__ */ i(_t, {
          children: /* @__PURE__ */ i(he, {
            tint: T()
          })
        })
      }),
      !p && /* @__PURE__ */ i(Tt, {
        color: t || Ct[y],
        height: Te[h],
        icon: l,
        width: Te[h],
        ...s
      })
    ]
  });
}
const wt = f.div.withConfig({
  displayName: "IconButton__SpinnerWrapper",
  componentId: "sc-bc9ab176-0"
})([
  "position:absolute;width:100%;height:100%;display:grid;place-items:center;z-index:",
  ";"
], H.elevate), _t = f.div.withConfig({
  displayName: "IconButton__LoadingContainer",
  componentId: "sc-bc9ab176-1"
})([
  "display:flex;align-items:center;justify-content:center;"
]), St = f.button.withConfig({
  displayName: "IconButton__StyledButton",
  componentId: "sc-bc9ab176-2"
})([
  "display:flex;align-items:center;justify-content:center;border:0;border-radius:",
  ";user-select:none;opacity:1;",
  " cursor:pointer;",
  " &.",
  "{background-color:",
  ";&:focus:not(.disabled):not(.loading):not(:active):not(.no-hover):not(.no-focus),&:hover:not(.disabled):not(.loading):not(:active):not(.no-hover){background-color:",
  ";}&:active:not(.disabled):not(.loading):not(.no-hover):not(.no-active){background-color:",
  ";}}&.",
  "{background-color:",
  ";outline:",
  " solid ",
  ";&:focus:not(.disabled):not(.loading):not(:active):not(.no-hover):not(.no-focus),&:hover:not(.disabled):not(.loading):not(:active):not(.no-hover){background-color:",
  ";}&:active:not(.disabled):not(.loading):not(.no-hover):not(.no-active){background-color:",
  ";}}&.",
  "{background-color:",
  ";&:focus:not(.disabled):not(.loading):not(:active):not(.no-hover):not(.no-focus),&:hover:not(.disabled):not(.loading):not(:active):not(.no-hover){background-color:",
  ";}&:active:not(.disabled):not(.loading):not(.no-hover):not(.no-active){background-color:",
  ";}}&.",
  "{background-color:",
  ";}&.",
  "&:not(.",
  "){height:32px;width:32px;}&.",
  "&:not(.",
  "){height:40px;width:40px;}&.disabled{opacity:",
  ";cursor:not-allowed;}"
], n.xsmall, G, Y, m.PRIMARY, e.black.medium, e.blue.dark, w(e.blue.dark, e.black.base, 0.2), m.SECONDARY, e.transparent, D.small, e.black.medium, e.blue.medium, e.blue.light, m.TERTIARY, e.transparent, e.blue.medium, e.blue.light, m.PLAIN, e.transparent, R.SLIM, m.PLAIN, R.NORMAL, m.PLAIN, be.disabled), Tt = f(K).withConfig({
  displayName: "IconButton__StyledIcon",
  componentId: "sc-bc9ab176-3"
})([
  "flex-shrink:0;"
]);
ne.propTypes = {
  color: r.string,
  disabled: r.bool,
  icon: r.shape({
    body: r.string.isRequired
  }).isRequired,
  iconProps: r.shape(),
  loading: r.bool,
  noActive: r.bool,
  noFocus: r.bool,
  noHover: r.bool,
  onClick: r.func,
  size: r.oneOf(Object.values(R)),
  type: r.oneOf(Object.values(m))
};
function It(o) {
  const { onConfirm: t = _, ...a } = o, l = Ce(), s = Ce(), [p, b] = z(!1), u = (g) => {
    t(g), b(!1);
  };
  return /* @__PURE__ */ C(ie, {
    children: [
      !p && /* @__PURE__ */ i(F, {
        onClick: () => b(!0),
        ...a
      }),
      p && /* @__PURE__ */ C(Et, {
        children: [
          /* @__PURE__ */ i(te, {
            content: "Cancel",
            id: l,
            children: /* @__PURE__ */ i(ne, {
              icon: j.baselineClose,
              onClick: () => b(!1),
              type: m.TERTIARY
            })
          }),
          /* @__PURE__ */ i(te, {
            content: "Confirm",
            id: s,
            children: /* @__PURE__ */ i(ne, {
              icon: j.baselineDelete,
              onClick: u,
              type: m.TERTIARY
            })
          })
        ]
      })
    ]
  });
}
const Et = f.div.withConfig({
  displayName: "ConfirmButton__Wrapper",
  componentId: "sc-d070a0e1-0"
})([
  "display:flex;"
]);
It.propTypes = {
  ...F.propTypes,
  onConfirm: r.func
};
const Ot = We`
  .react-datepicker-popper {
    z-index: ${H.dropdown};
  }

  .react-datepicker {
    border: none;
    background-color: ${e.white.primary};
    font-size: ${A.slarge};
    height: max-content;
    width: min-content;
    display: flex;
    flex-wrap: wrap;

    *:focus-visible {
      outline: none;
    }
  }

  .react-datepicker__header {
    padding-top: 0;
    padding-bottom: 0;
    background-color: ${e.white.primary};
    border: none;
  }

  .react-datepicker__navigation {
    top: ${n.smedium};

    width: ${n.xlarge};
    height: ${n.xlarge};

    border: none;
  }

  .react-datepicker__navigation--next {
    right: ${n.smedium};
  }

  .react-datepicker__navigation--previous {
    left: auto;
    right: ${n.xllarge};
  }

  .react-datepicker__navigation-icon::before {
    height: 6px;
    width: 6px;

    box-sizing: content-box;

    border-color: ${e.black.medium};
    border-width: ${D.medium} ${D.medium} 0 0;
  }

  .react-datepicker__triangle {
    display: none !important;
  }

  .react-datepicker__day--disabled {
    color: ${e.grey.secondary} !important;
    cursor: not-allowed;

    &:hover {
      background-color: ${e.white.primary} !important;
    }
  }

  .react-datepicker__month-container {
    height: 100%;
    border-radius: ${n.xsmall};
    border: ${D.small} solid ${e.blue.dark};
    box-shadow: ${n.xsmall} ${n.xsmall} ${e.black.mediumAlpha(15)};
  }

  .react-datepicker__month {
    padding: 0 ${n.xxlarge} ${n.xlarge};

    // Override
    margin: 0;
  }

  .react-datepicker__current-month {
    display: flex;
    padding: ${n.medium} ${n.large};

    color: ${e.black.medium};
    font-size: ${A.slarge};
    font-weight: ${me.medium};
    letter-spacing: 0.1px;

    // Override
    margin: 0;
  }

  .react-datepicker__day-names {
    display: flex;
    padding: 0 ${n.xxlarge};

    // Override
    margin: 0;
  }

  .react-datepicker__day-name {
    display: grid;
    place-content: center;

    height: ${n.xlarge};
    width: ${n.xlarge};

    color: ${e.black.medium};
    font-size: ${A.smedium};

    // Override
    margin: 0;
  }

  .react-datepicker__week {
    display: flex;
  }

  .react-datepicker__day {
    display: grid;
    place-content: center;

    height: ${n.xlarge};
    width: ${n.xlarge};

    margin: 0;

    border-radius: 50%;

    color: ${e.black.medium};
    ${mt}
    ${Y}

    &:hover {
      background-color: #EBF7FF;
    }

    &:not(.react-datepicker__day--in-selecting-range) {
      &:hover {
        border-radius: 50%;
      }
    }
  }

  .react-datepicker__day--selected {
    background-color: ${e.blue.dark};
    color: ${e.white.primary};

    &:hover {
      color: ${e.black.medium};
    }
  }

  .react-datepicker__day--today:not(.react-datepicker__day--in-range) {
    border: ${D.small} solid ${e.black.medium};
    border-radius: 50%;

    font-weight: ${me.normal};
  }

  .react-datepicker__day--today.react-datepicker__day--outside-month {
    color: ${e.black.medium};
    visibility: hidden;
  }

  .react-datepicker__day--outside-month {
    color: ${e.black.medium};
    opacity: 0.2;

    pointer-events: none;
  }

  .react-datepicker__day--001.react-datepicker__day--in-selecting-range {
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
  }

  .last-day-of-month.react-datepicker__day--in-selecting-range {
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
  }

  .react-datepicker__day--selected.react-datepicker__day--in-selecting-range {
    color: ${e.white.primary};
    background-color: ${e.black.primary};

    &:hover {
      background-color: ${e.black.primary};
    }
  }

  .react-datepicker__day--001.react-datepicker__day--in-range {
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
  }

  .last-day-of-month.react-datepicker__day--in-range {
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
  }

  .react-datepicker__day--in-range:first-child  {
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
  }

  .react-datepicker__day--in-range:last-child  {
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
  }

  .react-datepicker__day--range-start {
    color: ${e.white.primary};
    background-color: ${e.black.primary};
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
  }

  .react-datepicker__day--range-end {
    color: ${e.white.primary};
    background-color: ${e.black.primary};
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
  }
  // Days currently being selected (hovering over)
  .react-datepicker__day--selecting-range-start {
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .react-datepicker__day--selecting-range-end {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
  }

  .react-datepicker__day--in-selecting-range:first-child {
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
  }

  .react-datepicker__day--keyboard-selected {
    background-color: ${e.white.primary};
  }

  .react-datepicker__day--in-selecting-range:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;

    &:hover {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-top-right-radius: 24px;
      border-bottom-right-radius: 24px;
    }
  }

  .react-datepicker__day--in-selecting-range {
    &:hover {
      border-top-right-radius: 24px;
      border-bottom-right-radius: 24px;
    }
  }

  @media (min-width: 635px) {
    .react-datepicker {
      width: fit-content;
    }
  }
`;
function ye(o) {
  const { translucent: t = !0, visible: a = !1, ...l } = o, s = U();
  return /* @__PURE__ */ i(Yr, {
    appear: a,
    in: a,
    mountOnEnter: !0,
    nodeRef: s,
    timeout: ct,
    unmountOnExit: !0,
    children: /* @__PURE__ */ i(At, {
      ref: s,
      className: $({
        translucent: t
      }),
      ...l
    })
  });
}
const At = f.div.withConfig({
  displayName: "Overlay__StyledOverlay",
  componentId: "sc-f3724542-0"
})([
  "position:fixed;inset:0;background-color:",
  ";z-index:",
  ";opacity:0;&.enter{opacity:0;}&.enter-active.translucent{opacity:0.5;",
  "}&.enter-done.translucent{opacity:0.5;}&.appear{opacity:0;}&.appear-active.translucent{opacity:0.5;",
  "}&.exit.translucent{opacity:0.5;}&.exit-active.translucent{opacity:0;",
  "}&.exit-done.translucent{opacity:0;}"
], e.black.base, H.overlay, G, G, G);
ye.propTypes = {
  translucent: r.bool,
  visible: r.bool
};
const de = {
  label: "en-GB",
  value: $r
};
function Oe(o) {
  const { children: t, closeOnScroll: a = _, disabled: l = !1, displayFormat: s = re.DATE, format: p = re.ISO_DATE, id: b = void 0, maxDate: u = void 0, minDate: g = void 0, onChange: d = _, onClose: h = _, onOpen: y = _, placeholder: k = " ", required: v = !1, value: T = void 0, ...I } = o, [L, N] = z(), [c, O] = z(!1);
  oe(() => {
    Mr(de.label, de.value);
  }, []), oe(() => {
    N(we(T, p));
  }, [
    T
  ]);
  const M = (W) => {
    N(W), d({
      target: {
        value: at(we(lt(W).toISOString()), p)
      }
    });
  }, V = () => {
    O(!1), h();
  }, Z = () => {
    O(!0), y();
  };
  return (
    // ! Wrapped with div due to DatePicker adding sibling element for popup and to fix events propagation
    // TODO: what was the event propagation issue?
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    /* @__PURE__ */ C("div", {
      onClick: (W) => W.stopPropagation(),
      children: [
        /* @__PURE__ */ i(Ot, {}),
        /* @__PURE__ */ i(Fr, {
          closeOnScroll: a,
          customInput: t,
          dateFormat: s,
          disabled: l,
          id: b,
          locale: de.label,
          maxDate: u,
          minDate: g,
          onCalendarClose: V,
          onCalendarOpen: Z,
          onChange: M,
          placeholderText: k,
          portalId: "portal-root",
          required: v,
          selected: L,
          ...I
        }),
        c && /* @__PURE__ */ ce.createPortal(/* @__PURE__ */ i(ye, {
          translucent: !1,
          visible: c
        }), document.getElementById("portal-root"))
      ]
    })
  );
}
Oe.propTypes = {
  children: r.node.isRequired,
  closeOnScroll: r.func,
  disabled: r.bool,
  displayFormat: r.string,
  format: r.string,
  id: r.string,
  maxDate: r.instanceOf(Date),
  minDate: r.instanceOf(Date),
  onChange: r.func,
  onClose: r.func,
  onOpen: r.func,
  placeholder: r.string,
  required: r.bool,
  value: r.string
};
const Ae = /* @__PURE__ */ Ie(({ onClick: o = _, ...t }, a) => /* @__PURE__ */ i(F, {
  ref: a,
  ...t,
  onClick: (l) => {
    l.stopPropagation(), o(l);
  }
}));
Ae.propTypes = {
  ...F.propTypes,
  onClick: r.func
};
function Dt(o) {
  const { disabled: t, onChange: a = _, value: l, ...s } = o;
  return /* @__PURE__ */ i(Oe, {
    disabled: t,
    onChange: a,
    value: l,
    children: /* @__PURE__ */ i(Ae, {
      ...s
    })
  });
}
Dt.propTypes = {
  ...F.propTypes,
  onChange: r.func,
  value: r.string
};
const X = {
  applyMaxSize: {
    enabled: !0,
    fn: ({ options: o, state: t }) => {
      const { height: a } = t.modifiersData.maxSize, { minSize: l } = o;
      t.styles.popper.maxHeight = `${Math.max(l || 0, a)}px`;
    },
    name: "applyMaxSize",
    phase: "beforeWrite",
    requires: ["maxSize"]
  },
  maxSize: {
    ...Vr,
    options: {
      padding: 8
    }
  },
  offset: {
    name: "offset",
    options: {
      offset: [0, 8]
    }
  },
  preventOverflow: {
    name: "preventOverflow",
    options: {
      padding: 8
    }
  },
  sameWidth: {
    effect: ({ state: o }) => {
      o.elements.popper.style.width = `${o.elements.reference.offsetWidth}px`;
    },
    enabled: !0,
    fn: ({ state: o }) => {
      o.styles.popper.width = `${o.rects.reference.width}px`;
    },
    name: "sameWidth",
    phase: "beforeWrite",
    requires: ["computeStyles"]
  }
};
class De {
  constructor(t) {
    this.disabled = t.disabled || !1, this.id = t.id, this.label = t.label, this.onClick = t.onClick || _, this.tooltip = t.tooltip;
  }
}
const ae = {
  BOTTOM: {
    modifiers: [
      {
        name: "flip",
        options: {
          fallbackPlacements: ["top"]
        }
      },
      X.offset,
      X.preventOverflow
    ],
    placement: "bottom"
  },
  BOTTOM_END: {
    modifiers: [
      {
        name: "flip",
        options: {
          fallbackPlacements: ["bottom-start", "top-end", "top-start"]
        }
      },
      X.offset,
      X.preventOverflow
    ],
    placement: "bottom-end"
  }
}, B = {
  NORMAL: "normal",
  SLIM: "slim"
}, Rt = f.div.withConfig({
  displayName: "InputError",
  componentId: "sc-82dbfff3-0"
})([
  "padding-left:",
  ";color:",
  ";font-size:",
  ";"
], n.medium, e.red.primary, A.smedium);
function Re(o) {
  const { capitalisation: t = !0, required: a = !1, text: l } = o, s = a ? `${l}*` : l;
  return t ? Ee(s) : s;
}
Re.propTypes = {
  capitalisation: r.bool,
  required: r.bool,
  text: r.string.isRequired
};
const Le = {
  NUMBER: "number",
  PASSWORD: "password",
  TEXT: "text"
};
function Ne(o) {
  const { autoComplete: t = "off", disabled: a = !1, error: l = void 0, focused: s = !1, icon: p = null, iconColour: b = void 0, iconOnClick: u = void 0, id: g = void 0, inputRef: d = /* @__PURE__ */ Ve(), label: h = void 0, maximumValue: y = void 0, minimumValue: k = void 0, name: v = "default", onBlur: T = _, onChange: I = _, onClick: L = _, onFocus: N = _, onKeyDown: c = _, placeholder: O = void 0, readOnly: M = !1, required: V = !1, size: Z = B.NORMAL, type: W = Le.TEXT, value: Fe = "" } = o, Me = () => p || (l ? j.baselineError : null), Be = () => {
    if (p) return b || e.black.medium;
    if (l) return e.red.primary;
  }, ve = (x) => {
    d.current.focus(), L(x, "input");
  }, ze = (x) => {
    M || c(x, "input");
  };
  return /* @__PURE__ */ C(Lt, {
    className: $({
      disabled: a,
      error: l,
      focused: s,
      "read-only": M,
      "with-icon": p,
      "with-label": h
    }),
    children: [
      /* @__PURE__ */ i("input", {
        ref: d,
        autoComplete: t,
        className: $({
          [Z]: !0
        }),
        disabled: a,
        id: g,
        max: y,
        min: k,
        onBlur: (x) => T(x, "input"),
        onChange: (x) => I(x, "input"),
        onClick: (x) => L(x, "input"),
        onFocus: (x) => N(x, "input"),
        onKeyDown: ze,
        placeholder: O,
        readOnly: M,
        required: V,
        type: W,
        value: Fe,
        ...S(q(`${v}-input`))
      }),
      /* @__PURE__ */ i("label", {
        htmlFor: g,
        onClick: ve,
        role: "presentation",
        children: h && /* @__PURE__ */ C(ie, {
          children: [
            /* @__PURE__ */ i(ee, {}),
            /* @__PURE__ */ i(Re, {
              required: V,
              text: h
            })
          ]
        })
      }),
      (p || l) && /* @__PURE__ */ i(K, {
        className: $({
          clickable: u,
          "input-icon": !0,
          [Z]: !0
        }),
        color: Be(),
        height: 24,
        icon: Me(),
        onClick: (x) => u && u(x) || ve(x),
        onMouseDown: (x) => x.preventDefault(),
        width: 24
      }),
      l && /* @__PURE__ */ i(Rt, {
        ...S(q(`${v}-input-error`)),
        children: l
      })
    ]
  });
}
const ee = f.div.withConfig({
  displayName: "Input__LabelLine",
  componentId: "sc-60fa5a4a-0"
})([
  "position:absolute;top:5px;left:0;width:100%;height:3px;background-color:",
  ";z-index:",
  ";"
], e.white.primary, H.hidden), Lt = f.div.withConfig({
  displayName: "Input__StyledInput",
  componentId: "sc-60fa5a4a-1"
})([
  "position:relative;width:100%;display:flex;flex-direction:column;gap:",
  ";&.error{> input{padding-left:calc(",
  " - 1px);border:2px solid ",
  ";}> label{color:",
  ";",
  "{height:4px;}}}&.disabled{opacity:",
  ";> input{cursor:default;}}&.focused:not(.error){> input{padding-left:calc(",
  " - 1px);border:2px solid ",
  ";~ label{padding:0 ",
  ";color:",
  ";font-size:",
  ";transform:translateX(-2px) translateY(-22px);",
  "{height:4px;}}}}&:hover:not(.disabled):not(.error):not(.focused){> input:not(:focus){border-color:",
  ";}}input{&.",
  "{height:",
  ";}&.",
  "{height:",
  ";}width:100%;border:1px solid #546077;border-radius:",
  ";padding:",
  ";font-size:",
  ";color:",
  ";&:focus ~ label,&:placeholder-shown ~ label,&:not([value='']) ~ label{padding:0 ",
  ";font-size:",
  ";transform:translateX(-2px) translateY(-22px);}&::placeholder{color:#7b87a0;}}:not(.error){input{&:focus{padding-left:calc(",
  " - 1px);border:2px solid ",
  ";~ label{color:",
  ";",
  "{height:4px;}}}}}label{position:absolute;top:",
  ";left:",
  ";margin:0;color:",
  ";font-size:",
  ";font-weight:",
  ";cursor:text;",
  ";}&.with-icon{input{padding-right:",
  ";}}&.read-only:not(.disabled){input,label,.input-icon{cursor:pointer;}}.input-icon{position:absolute;&.",
  "{top:",
  ";}&.",
  "{top:13px;}right:",
  ";cursor:text;&.clickable{cursor:pointer;}}"
], n.xsmall, n.medium, e.red.primary, e.red.primary, ee, be.disabled, n.medium, e.blue.dark, n.xsmall, e.blue.dark, A.smedium, ee, e.black.primary, B.SLIM, n.xxlarge, B.NORMAL, n.xllarge, n.xsmall, n.medium, A.slarge, e.black.medium, n.xsmall, A.smedium, n.medium, e.blue.dark, e.blue.dark, ee, n.medium, n.medium, e.black.medium, A.slarge, me.normal, pt, n.xxlarge, B.SLIM, n.small, B.NORMAL, n.medium);
Ne.propTypes = {
  autoComplete: r.string,
  disabled: r.bool,
  error: r.string,
  focused: r.bool,
  icon: r.shape({
    body: r.string.isRequired
  }),
  iconColour: r.string,
  iconOnClick: r.func,
  id: r.string,
  inputRef: r.shape({
    current: r.oneOfType([
      r.shape({}),
      r.node
    ])
  }),
  label: r.string,
  maximumValue: r.number,
  minimumValue: r.number,
  name: r.string,
  onBlur: r.func,
  onChange: r.func,
  onClick: r.func,
  onFocus: r.func,
  onKeyDown: r.func,
  placeholder: r.string,
  readOnly: r.bool,
  required: r.bool,
  size: r.oneOf(Object.values(B)),
  type: r.oneOf(Object.values(Le)),
  value: r.oneOfType([
    r.string,
    r.number
  ])
};
const Pe = Ue([
  "position:absolute;max-height:400px;max-width:400px;border:",
  " solid ",
  ";border-radius:",
  ";box-shadow:",
  " ",
  " ",
  ";overflow:auto;z-index:",
  ";"
], D.small, e.blue.dark, n.xsmall, n.xsmall, n.xsmall, e.black.mediumAlpha(15), H.dropdown), va = f.div.withConfig({
  displayName: "DropdownMenu",
  componentId: "sc-1cc01970-0"
})([
  "",
  ""
], Pe);
function ke(o) {
  const { children: t, element: a, menuStyle: l = void 0, menuVisible: s, onToggle: p, placement: b = ae.BOTTOM_END, portals: u = {
    dropdown: null,
    overlay: null
  } } = o, g = U(), d = U(), h = U(), y = (k) => {
    k.stopPropagation(), p(k);
  };
  return oe(() => (d.current && h.current && (g.current = qr(d.current, h.current, b)), () => {
    var k;
    return (k = g.current) == null ? void 0 : k.destroy();
  }), [
    d,
    h,
    s
  ]), /* @__PURE__ */ C(Nt, {
    children: [
      /* @__PURE__ */ i(Pt, {
        ref: d,
        onClick: y,
        children: a
      }),
      s && /* @__PURE__ */ ce.createPortal(/* @__PURE__ */ i(ye, {
        onClick: y,
        translucent: !1,
        visible: s
      }), u.overlay || document.body),
      s && /* @__PURE__ */ ce.createPortal(/* @__PURE__ */ i($t, {
        ref: h,
        style: l,
        ...S("dropdown-menu"),
        children: t
      }), u.dropdown || document.body)
    ]
  });
}
const Nt = f.div.withConfig({
  displayName: "Dropdown__StyledDropdown",
  componentId: "sc-ed31074c-0"
})([
  "position:relative;"
]), Pt = f.div.withConfig({
  displayName: "Dropdown__DropdownElement",
  componentId: "sc-ed31074c-1"
})([
  ""
]), $t = f.ul.withConfig({
  displayName: "Dropdown__DropdownMenu",
  componentId: "sc-ed31074c-2"
})([
  "",
  ""
], Pe);
ke.propTypes = {
  children: r.node.isRequired,
  element: r.node.isRequired,
  menuStyle: r.shape({}),
  menuVisible: r.bool.isRequired,
  onToggle: r.func.isRequired,
  placement: r.shape({
    placement: r.string
  }),
  portals: r.shape({
    dropdown: r.oneOfType([
      r.shape({}),
      r.node
    ]),
    overlay: r.oneOfType([
      r.shape({}),
      r.node
    ])
  })
};
function Ft(o) {
  const { defaultColor: t = e.yellow.secondary, onSave: a, placement: l = ae.BOTTOM_END, portals: s = {
    dropdown: null,
    overlay: null
  }, presetColors: p = [] } = o, [b, u] = z({
    colorPicker: p.length === 0,
    menu: !1
  }), [g, d] = z({
    input: t,
    selected: t
  }), h = () => {
    u({
      colorPicker: p && !1,
      menu: !b.menu
    });
  }, y = (c) => {
    d((O) => ({
      ...O,
      input: c,
      selected: c
    })), h(), a(c);
  }, k = (c) => {
    d({
      input: c,
      selected: c
    }), a(c);
  }, v = (c) => {
    /^#[0-9A-F]{6}$/i.test(c) ? (d({
      input: c,
      selected: c
    }), a(c)) : d((O) => ({
      ...O,
      input: c
    }));
  }, T = () => /* @__PURE__ */ C(ie, {
    children: [
      /* @__PURE__ */ i(Mt, {
        children: /* @__PURE__ */ i(Ur, {
          color: g.selected,
          disableAlpha: !0,
          onChange: (c) => k(c.hex),
          ...S("color-picker")
        })
      }),
      /* @__PURE__ */ C(Bt, {
        children: [
          /* @__PURE__ */ i(Ne, {
            onChange: (c) => v(c.target.value),
            size: B.SLIM,
            value: g.input,
            ...S("color-picker-input")
          }),
          /* @__PURE__ */ i(ne, {
            icon: j.baselineCheck,
            onClick: () => h()
          })
        ]
      })
    ]
  }), I = () => /* @__PURE__ */ C(zt, {
    children: [
      p.map((c) => /* @__PURE__ */ i(Ht, {
        $color: c,
        className: $({
          selected: c === g.selected
        }),
        onClick: () => y(c),
        ...S(`preset-color-${c}`)
      }, c)),
      /* @__PURE__ */ i(Vt, {
        onClick: () => u((c) => ({
          ...c,
          colorPicker: !b.colorPicker
        }))
      })
    ]
  }), L = () => /* @__PURE__ */ i(Wt, {
    $color: g.selected,
    onClick: () => h(),
    ...S("color-picker-button"),
    children: /* @__PURE__ */ i(K, {
      color: se(g.selected).isLight() ? e.black.primary : e.white.primary,
      height: 24,
      icon: j.baselineFormatColorFill,
      width: 20
    })
  }), N = {
    backgroundColor: e.white.primary,
    display: "block",
    minWidth: "160px",
    padding: n.medium
  };
  return /* @__PURE__ */ i(ke, {
    element: L(),
    menuStyle: N,
    menuVisible: b.menu,
    onToggle: () => u((c) => ({
      ...c,
      menu: !b.menu
    })),
    placement: l,
    portals: s,
    children: p && !b.colorPicker ? I() : T()
  });
}
const Mt = f.div.withConfig({
  displayName: "ColorPicker__ColorPickerWrapper",
  componentId: "sc-69c15b74-0"
})([
  "padding-bottom:",
  ";"
], n.medium), Bt = f.div.withConfig({
  displayName: "ColorPicker__ColorPickerOptions",
  componentId: "sc-69c15b74-1"
})([
  "width:100%;display:flex;justify-content:space-between;align-items:center;gap:",
  ";"
], n.medium), zt = f.div.withConfig({
  displayName: "ColorPicker__PresetWrapper",
  componentId: "sc-69c15b74-2"
})([
  "display:grid;grid-template-columns:repeat(3,1fr);grid-column-gap:",
  ";grid-row-gap:",
  ";"
], n.medium, n.medium), Ht = f.div.withConfig({
  displayName: "ColorPicker__PresetColor",
  componentId: "sc-69c15b74-3"
})([
  "height:",
  ";width:",
  ";border-radius:",
  ";background-color:",
  ";cursor:pointer;&.selected{outline:1px ",
  " inset;}&:hover{outline:",
  " solid ",
  ";}"
], n.xlarge, n.xlarge, D.large, (o) => o.$color, e.black.medium, n.msmall, e.blue.light), Vt = f.div.withConfig({
  displayName: "ColorPicker__ColorPickerButton",
  componentId: "sc-69c15b74-4"
})([
  "height:",
  ";width:",
  ";border-radius:",
  ";background:conic-gradient( from 90deg,rgba(255,0,0,1),rgba(255,255,0,1),rgba(0,192,255,1),rgba(192,0,255,1) );cursor:pointer;&:hover{outline:6px solid ",
  ";}"
], n.xlarge, n.xlarge, D.large, e.blue.light), Wt = f.div.withConfig({
  displayName: "ColorPicker__StyledColorPicker",
  componentId: "sc-69c15b74-5"
})([
  "position:relative;display:flex;min-height:",
  ";min-width:",
  ";border:1px ",
  " solid;border-radius:",
  ";background-color:",
  ";cursor:pointer;align-items:center;justify-content:center;"
], n.xllarge, n.xllarge, e.black.medium, D.large, (o) => o.$color);
Ft.propTypes = {
  defaultColor: r.string,
  onSave: r.func.isRequired,
  placement: r.shape({
    placement: r.string
  }),
  portals: r.shape({
    dropdown: r.oneOfType([
      r.shape({}),
      r.node
    ]),
    overlay: r.oneOfType([
      r.shape({}),
      r.node
    ])
  }),
  presetColors: r.arrayOf(r.string)
};
const xa = f.li.withConfig({
  displayName: "DropdownMenuOption",
  componentId: "sc-540e3f7e-0"
})([
  "height:",
  ";padding:",
  ";font-size:",
  ";background-color:",
  ";",
  " color:",
  ";cursor:pointer;",
  " &:hover:not(.no-selectable){background-color:",
  ";}&.no-selectable{cursor:default;}"
], n.xllarge, n.medium, A.slarge, e.white.primary, Y, e.black.medium, ge, e.blue.light);
function $e(o) {
  const { children: t, items: a = [], menuStyle: l = void 0, placement: s = ae.BOTTOM_END } = o, [p, b] = z(!1), u = (d) => {
    d.disabled || (d.onClick(), b(!1));
  };
  return /* @__PURE__ */ i(ke, {
    element: t,
    menuStyle: l,
    menuVisible: p,
    onToggle: () => b(!p),
    placement: s,
    children: a.map((d) => /* @__PURE__ */ i(te, {
      content: d.disabled && d.tooltip ? d.tooltip : null,
      id: d.id,
      place: fe.LEFT,
      children: /* @__PURE__ */ i(Ut, {
        className: $({
          disabled: d.disabled
        }),
        onClick: (h) => {
          h.stopPropagation(), u(d);
        },
        ...S(q(`${d.id}-dropdown-menu-item`)),
        children: d.label
      })
    }, d.id))
  });
}
const Ut = f.li.withConfig({
  displayName: "DropdownWithOptions__DropdownMenuItem",
  componentId: "sc-f8db0877-0"
})([
  "height:",
  ";padding:",
  ";font-size:",
  ";background-color:",
  ";",
  " ",
  " cursor:pointer;&:hover:not(.disabled){background-color:",
  ";",
  "}&.disabled{color:",
  ";}"
], n.xllarge, n.medium, A.slarge, e.white.primary, Y, ge, e.blue.light, Y, e.grey.quartenary);
$e.propTypes = {
  children: r.node.isRequired,
  items: r.arrayOf(r.instanceOf(De)),
  menuStyle: r.shape({}),
  placement: r.shape({
    placement: r.string
  })
};
function qt(o) {
  const { items: t = [], placement: a = ae.BOTTOM, ...l } = o;
  return /* @__PURE__ */ i($e, {
    items: t,
    menuStyle: {
      width: "100%"
    },
    placement: a,
    children: /* @__PURE__ */ i(F, {
      ...l
    })
  });
}
qt.propTypes = {
  ...F.propTypes,
  items: r.arrayOf(r.instanceOf(De)),
  placement: r.shape({
    placement: r.string
  })
};
export {
  Ot as $,
  pt as A,
  ya as B,
  D as C,
  re as D,
  R as E,
  Ce as F,
  ha as G,
  F as H,
  Ne as I,
  pa as J,
  ne as K,
  m as L,
  ia as M,
  aa as N,
  ye as O,
  da as P,
  Q,
  ma as R,
  la as S,
  te as T,
  It as U,
  E as V,
  Ae as W,
  Dt as X,
  qt as Y,
  J as Z,
  he as _,
  A as a,
  De as a0,
  Ft as a1,
  ke as a2,
  va as a3,
  $e as a4,
  Le as a5,
  pe as a6,
  we as a7,
  at as a8,
  sa as a9,
  ca as aa,
  lt as ab,
  ua as ac,
  ga as ad,
  fa as ae,
  w as af,
  ct as ag,
  mt as ah,
  G as ai,
  Y as b,
  e as c,
  ka as d,
  st as e,
  me as f,
  S as g,
  ba as h,
  ge as i,
  j,
  na as k,
  q as l,
  B as m,
  _ as n,
  be as o,
  Oe as p,
  H as q,
  Re as r,
  n as s,
  Ee as t,
  Rt as u,
  Pe as v,
  xa as w,
  ae as x,
  X as y,
  fe as z
};
